import { DivergenceStatusEnum } from "@/enum/divergence-status";

export interface ReversibleRow {
  status?: DivergenceStatusEnum | null;
  reverted?: boolean;
  closed_period?: boolean;
  payroll_voucher?: unknown;
}

const AWAITING_DECISION: readonly DivergenceStatusEnum[] = [
  DivergenceStatusEnum.PENDING,
  DivergenceStatusEnum.ACTIVE,
];

export const canReverseRow = (row: ReversibleRow): boolean =>
  !row.reverted && row.status === DivergenceStatusEnum.APPROVED;

export const canDecideRow = (row: ReversibleRow): boolean =>
  AWAITING_DECISION.includes(row.status as DivergenceStatusEnum);
